import React  from 'react';
import { Provider } from "react-redux"
import { HashRouter  } from "react-router-dom";

import { Header } from  "../../components/header";
import { HomeLink } from  "../../components/home-link";
import routes from "../../routes/routes";
import configureStore, { sagaMiddleware } from "./store"

import './App.css';
import ExternalWindow from "../external-window"
// sagas 
import sagas from "./sagas"


const store = configureStore();  
sagaMiddleware.run(sagas)

 const App: React.FC = props => { 

    
    return (     
        <div className="App">
            <Provider store={store}>
                <ExternalWindow/>
                <Header/> 
                <HashRouter>
                    <HomeLink/>    
                    {routes}
                </HashRouter>
            </Provider>
            
        </div>
        

    )
  }


export default App;
